import React, { useMemo, memo } from "react";
import dayjs from "dayjs";
import { Box, Chip } from "@mui/material";
import { BsFillPencilFill } from "react-icons/bs";

const formatdate = (date) => date.split("T")[0];

function getStartAndEndDates(obj, project) {
    let ms = Object.entries(obj || {})
        .filter(([key]) => key !== "value")
        .map(([_, dateStr]) => new Date(dateStr).getTime())
        .filter((n) => !isNaN(n));

    if (ms.length === 0) {
        ms = [
            new Date(
                formatdate(project?.start_project_date || "1970-01-01")
            ).getTime(),
        ];
    }

    const min = Math.min(...ms);
    const max = Math.max(...ms);

    return {
        startDate: formatdate(new Date(min).toISOString()),
        endDate: formatdate(new Date(max).toISOString()),
    };
}

/* ✅ Memoized Row Component */
const Timeline = memo(function ProgressRow({
    item,
    days,
    timelineStart,
    onProgressClick,
    project,
}) {
    // ✅ Compute derived data WITHOUT mutating props
    const processedItem = useMemo(() => {
        const sed = getStartAndEndDates(item.progress, project);

        return {
            ...item,
            startDate: sed.startDate,
            progressDate: sed.endDate,
            endDate: formatdate(item.deadline),
            color: "#ff5c5c",
            progress_color:
                item?.progress?.value == 100
                    ? "#1c8832ff"
                    : "#3707f7ff",
        };
    }, [item, project]);

    const totalDays = days.length;

    const startIndex = dayjs(processedItem.startDate).diff(
        dayjs(timelineStart),
        "day"
    );
    const endIndex = dayjs(processedItem.endDate).diff(
        dayjs(timelineStart),
        "day"
    );

    const left = (startIndex / totalDays) * 100;
    const width = ((endIndex - startIndex + 1) / totalDays) * 100;
    const percentage = processedItem?.progress?.value || 0;

    // ✅ Memoize styles
    const wrapperStyle = useMemo(
        () => ({
            left: `${left}%`,
            width: `${width}%`,
        }),
        [left, width]
    );

    const progressStyle = useMemo(
        () => ({
            background: processedItem.progress_color,
            width: `${percentage}%`,
            opacity: 0.7,
            position: "absolute",
            top: 0,
        }),
        [processedItem.progress_color, percentage]
    );

    return (
        <tr>
            <td className="task-name input-label">
                {processedItem.task_name}
                <BsFillPencilFill
                    onClick={() => onProgressClick(processedItem)}
                    style={{ marginLeft: 6, cursor: "pointer" }}
                />
            </td>

            <td colSpan={totalDays} className="progress-cell input-label">
                <div className="progress-wrapper-hide">
                    <div
                        className="progress-wrapper input-label"
                        style={wrapperStyle}
                        onClick={() => onProgressClick(processedItem)}
                        title={percentage}
                    >
                        <div
                            className="progress-bar"
                            style={{ background: processedItem.color }}
                        />

                        <div
                            className="progress-bar"
                            style={{ ...progressStyle, backgroundColor: 'green' }}
                            title={percentage}
                        />
                    </div>
                </div>
            </td>
        </tr>
    );
});

export default Timeline